/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const ALLOCATE_PAYMENTS_2_INVOICEHEADER =
  'ALLOCATE_PAYMENTS_2_INVOICEHEADER';
export const GET_PQASGRID_AP2 = 'GET_PQASGRID_AP2';
export const GET_POST_INIT_BY_MIR = 'GET_POST_INIT_BY_MIR';
export const PQAS_DRUGS_PAID_FULLY_OR_PARTIALLY =
  'PQAS_DRUGS_PAID_FULLY_OR_PARTIALLY';
export const URA_FROM_DQD = 'URA_FROM_DQD';
export const ADJ_DISPUTE_CODES = 'ADJ_DISPUTE_CODES';
export const GET_PQAS_SUMMARY_GRID = 'GET_PQAS_SUMMARY_GRID';
export const PQAS_TG_ACTIONS = 'PQAS_TG_ACTIONS';
export const PQRS_ALLOCATE_PAYMENT_DETAIL_SCREEN =
  'PQRS_ALLOCATE_PAYMENT_DETAIL_SCREEN';
export const NP_SUSPENDED = 'NP_SUSPENDED';
export const PQAS_DRUGS_PAID_TRANSACTION_AMT =
  'PQAS_DRUGS_PAID_TRANSACTION_AMT';
export const DEALLOCATE_NDC_PQAS = 'DEALLOCATE_NDC_PQAS';
export const ID_DEALLOC_PQAS = 'ID_DEALLOC_PQAS';
export const GET_RECALC_VALUES_FOR_PQAS = 'GET_RECALC_VALUES_FOR_PQAS';
export const SET_LOAD_INITIAL_FLAG = 'SET_LOAD_INITIAL_FLAG';
export const SUM_ORG_PAID_AMT = 'SUM_ORG_PAID_AMT';
export const PRIOR_CURRENT_UNITS_RESPONSE = 'PRIOR_CURRENT_UNITS_RESPONSE';
export const IDC_CURR_URA = 'IDC_CURR_URA';
export const UPDATE_PQAS_GRID = 'UPDATE_PQAS_GRID';
export const SAVE_DETAILS = 'SAVE_DETAILS';
export const ISTR_DEALLOC_DATA = 'ISTR_DEALLOC_DATA';
export const SET_PAID_ALLOCATED_AMT = 'SET_PAID_ALLOCATED_AMT';
export const SET_PRE_INIT_DATA = 'SET_PRE_INIT_DATA';
export const GET_DELETED_ROW = 'GET_DELETED_ROW';
export const DISABLED_INT_PAID_COLUMN_PQAS = 'DISABLED_INT_PAID_COLUMN_PQAS';
export const LOAD_PQAS_GRID_ERROR = 'LOAD_PQAS_GRID_ERROR';
export const DUPLICATE_PQAS_GRID = 'DUPLICATE_PQAS_GRID';
export const CURR_COL_ID = 'CURR_COL_ID';
export const ADD_OR_DUPLICATE_NDC_PQAS = 'ADD_OR_DUPLICATE_NDC_PQAS';
export const ALLOCATE_PAYMENTS_2_IS_COLUMN_DONE =
  'ALLOCATE_PAYMENTS_2_IS_COLUMN_DONE';
export const CLEAR_NP_SUSPENDED = 'CLEAR_NP_SUSPENDED';
export const UPDATE_PQAS_PREV_NEXT_QTR = 'UPDATE_PQAS_PREV_NEXT_QTR';
export const SET_IS_CANCELING = 'SET_IS_CANCELING';
export const SET_DUPLICATE_PQAS_INTEREST_INDEX =
  'SET_DUPLICATE_PQAS_INTEREST_INDEX';
export const ALLOCATE_PAYMENTS_2_IB_OPENING = 'ALLOCATE_PAYMENTS_2_IB_OPENING';
